<template>
  <v-dialog
    v-if="!!test"
    :value="!!test"
    max-width="600px"
    persistent
    @keydown.esc="done"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span class="headline">{{ $t("tests.testEdit.title") }}</span>
      </v-card-title>
      <test-edit
        :test="test"
        :locales="locales"
        @done="testDone"
        @test-saved="assignTest($event)"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import TestEdit from "@/components/TestEdit";

import AssignTestToInstructionQuery from "@/graphql/AssignTestToInstruction.gql";

export default {
  props: ["test", "instructionId"],
  components: { TestEdit },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["locales"]),
  },
  methods: {
    testDone() {
      this.$emit("test-done");
    },

    assignTest(testId) {
      this.loading = true;

      this.$apollo
        .mutate({
          mutation: AssignTestToInstructionQuery,
          variables: {
            instructionId: this.instructionId,
            testId: testId,
          },
        })
        .finally(() => {
          this.testDone();
          this.loading = false;
        });
    },
  },
};
</script>
